// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// IMPORTANT
// Add new SPA page pathes to the src/SPA_PATHES.ts
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

export const refillBalance = '/balance/payment';

export const womenCatalog = '/women';
export const notFound = '/404';
export const mainPage = '/';

export const subscriptionNewProducts = '/my/favorite-shop';
export const favouriteProducts = '/my/favourites';

export const brands = '/brands';
export const brandFeed = '/brands/:slug([a-zA-z0-9\\-]+)';

export const aboutMoneyTransfer = '/page/posluga-perekazu-koshtiv';
export const deliveryRules = '/page/pravila-oplati-za-dostavku';

// add here new data if added new root category SHAF-153
// Feed
// Feed links may be used directly (without variable) to prevent
// replacement `/` on `%2F` in slug
export const baseCatalog = '/:namespace(women|kids|men|home|cosmetics|clothes|forkids|sport|aksesuary|electronics|auto|pet|garden|building)';
export const baseCatalogBrand = `${baseCatalog}/brand-:brand([a-zA-z0-9\\-]+)`;
export const baseCatalogCity = `${baseCatalog}/gorod-:city([a-zA-z0-9\\-]+)`;
export const catalog = `${baseCatalog}/:slug(.+)`;
export const catalogBrand = `${catalog}/brand-:brand([a-zA-z0-9\\-]+)`;
export const catalogCity = `${catalog}/gorod-:city([a-zA-z0-9\\-]+)`;

// Product details
export const productDetails = (
  `${baseCatalog}/:category+/:productId(\\d+)-:slug([\\w-]+)`
) as `${typeof baseCatalog}/:category+/:productId(\\d+)/:slug([\\w-]+)`;

export const catalogBlock = '/catalog-ssr-block/:categoryId';

export const tag = '/:slug([\\w-]+).xhtml' as '/:slug([\\w-]+)';

export const productRedirect = '/p/:productId';

export const savedSearchNewProducts = `${catalog}`;

// Modal hashes
export const deliverySettingsUpdate = '#deliverySettingsUpdate';
export const basketHash = '#basket';

// Warning: hardcoded on emails/mobile pushes
// Mobiles cannot use urls with hash(#), so they use this link
// for basket.
export const basketOnMain = '/basket';
